import { usePropertyUrl } from '~/utilities/usePropertyUrl';

export function useIsSI(): boolean {
  const propertyUrl = usePropertyUrl();

  // Get the domain of the property URL
  const domain = propertyUrl.split('/')[2];

  return domain.includes('si.com');
}
